// src/services/CountryService.js
import api from "./api";

export function getCurrency(page = 1, limit = 10, search = "") {
    return api.get(`/currency?page=${page}&limit=${limit}&search=${search}`);
}

export function getCurrenciesDropdown() {
    return api.get("/currency/dropdown");
}

export function getCurrencyById(id) {
    return api.get(`/currency/${id}`);
}

export function addCurrency(data) {
    return api.post("/currency", data);
}

export function updateCurrency(id, data) {
    return api.put(`/currency/${id}`, data);
}

export function deleteCurrency(id) {
    return api.delete(`/currency/${id}`);
}
